



















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class InfoTabs extends Vue {
	@Prop({ default: 0 })
	public readonly tabindex!: number;

	public smallScreen = window.innerWidth;

	public created() {
		window.addEventListener('resize', this.myEventHandler);
	}

	public destroyed() {
		window.removeEventListener('resize', this.myEventHandler);
	}

	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}

	@Emit('change')
	public onTabChange(newTabIndex: number): number {
		return newTabIndex;
	}
}
